import { render, staticRenderFns } from "./welinkCode.vue?vue&type=template&id=179afd69&scoped=true"
import script from "./welinkCode.vue?vue&type=script&lang=js"
export * from "./welinkCode.vue?vue&type=script&lang=js"
import style0 from "./welinkCode.vue?vue&type=style&index=0&id=179afd69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179afd69",
  null
  
)

export default component.exports